import React from "react"
import PageTransition from "./src/components/PageTransition"
import ErrorBoundary from "./src/components/ErrorBoundary"
import { ApolloProvider } from "@apollo/client"
import client from "./src/gatsby-plugin-apollo/client"

export const wrapPageElement = ({ element, props }) => {
  return (
    <ErrorBoundary>
      <PageTransition {...props}>{element}</PageTransition>
    </ErrorBoundary>
  )
}

export const shouldUpdateScroll = () => {
  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual"
  }

  return false
}

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>{element}</ApolloProvider>
)